import Papa from 'papaparse';
import * as HtmlParsing from "./HtmlParsing";
import {aiStore} from "../../index";
import {handleAbort} from "./PdfParser";

async function readFileAsText(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(new Error('Failed to read file'));
        reader.readAsText(file);
    });
}

function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function isImageValue(val) {
    return typeof val === 'string' && (
        val.trim().match(/\.(jpeg|jpg|png|gif|webp)$/i) ||
        val.startsWith('data:image/')
    );
}

async function handleImageValue(val, file, imageIndex) {
    try {
        if (val.startsWith('data:image/')) {
            return { success: true, src: val };
        } else if (val.trim().match(/\.(jpeg|jpg|png|gif|webp)$/i)) {
            if (val.startsWith('http')) {
                return { success: true, src: val };
            } else {
                try {
                    const response = await fetch(val);
                    if (response.ok) {
                        const blob = await response.blob();
                        const extension = val.split('.').pop().toLowerCase();
                        const fileId = await HtmlParsing.uploadImageFromFile(blob, file, imageIndex, extension);

                        if (fileId) {
                            return { success: true, src: fileId };
                        }
                    }
                } catch (error) {
                }

                return { success: true, src: val };
            }
        }
        return { success: false, error: 'Invalid image format' };
    } catch (error) {
        return { success: false, error: error.message };
    }
}

async function writeChunkToHtml(file, rows, headers, page, imageIndex) {
    let html = '<table border="1"><thead><tr>';
    headers.forEach(h => html += `<th>${escapeHtml(h)}</th>`);
    html += '</tr></thead><tbody>';

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        html += '<tr>';

        for (let j = 0; j < headers.length; j++) {
            const h = headers[j];
            const val = row[h];

            if (isImageValue(val)) {
                const imageResult = await handleImageValue(val, file, imageIndex);
                if (imageResult.success) {
                    imageIndex++;
                    html += `<td><img src="${imageResult.src}" width="100" alt="Image ${imageIndex}"/></td>`;
                } else {
                    html += `<td>(Image failed: ${imageResult.error})</td>`;
                }
            } else {
                html += `<td>${escapeHtml(val ?? '')}</td>`;
            }
        }

        html += '</tr>';
    }

    html += '</tbody></table>';
    return html;
}

async function convertCsvToHtml(file, isEmbedding, abortedFiles, chunkSize = 100) {
    const csvText = await readFileAsText(file);
    const chunks = [];
    let headers = [];
    let currentChunk = [];
    let pageIndex = 1;
    let imageIndex = 1;

    const parsed = Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true
    });

    const totalRows = parsed.data.length;

    for (let index = 0; index < parsed.data.length; index++) {
        if (handleAbort(file, abortedFiles, isEmbedding)) {
            return [];
        }
        const row = parsed.data[index];

        if (headers.length === 0) {
            headers = Object.keys(row);
        }

        currentChunk.push(row);

        if (currentChunk.length >= chunkSize) {
            const htmlChunk = await writeChunkToHtml(file, currentChunk, headers, pageIndex++, imageIndex);
            chunks.push(htmlChunk);
            currentChunk = [];
            aiStore.sendAiProgressLoaderValue(file.name, (index + 1) * 100 / totalRows);
        }
    }

    if (currentChunk.length > 0) {
        const htmlChunk = await writeChunkToHtml(file, currentChunk, headers, pageIndex++, imageIndex);
        chunks.push(htmlChunk);
    }

    if (typeof HtmlParsing !== 'undefined' && HtmlParsing.splitHtmlIntoChunks) {
        const allHtml = chunks.join('');
        return HtmlParsing.splitHtmlIntoChunks(allHtml);
    }

    return chunks;
}

export { convertCsvToHtml };